import { IFilterColor } from '../interfaces/i-filter';

export const FAST_FILTERS: IFilterColor[] = [
    {
      id: '89a07117-6a35-46a8-95fc-25263708e1b7',
      description: 'Almoço',
      type: 'MOMENT',
      regularClasses:
        'bg-[#069E52] text-white border-[#069E52]  hover:bg-white hover:text-[#069E52]',
      activeClasses:
        'bg-white text-[#069E52] border-[#069E52]  hover:bg-[#069E52] hover:text-white',
    },
    {
      id: '89ba7a6a-79e1-4b42-993d-bee51776cb5b',
      description: 'Jantar',
      type: 'MOMENT',
      regularClasses:
        'bg-[#2E178C] text-white border-[#2E178C]  hover:bg-white hover:text-[#2E178C]',
      activeClasses:
        'bg-white text-[#2E178C] border-[#2E178C]  hover:bg-[#2E178C] hover:text-white',
    },
    {
      id: '0054363f-226e-4241-a645-c0b6de25e132',
      description: 'Carnes',
      type: 'CATEGORY',
      regularClasses:
        'bg-[#A9190B] text-white border-[#A9190B]  hover:bg-white hover:text-[#A9190B]',
      activeClasses:
        'bg-white text-[#A9190B] border-[#A9190B]  hover:bg-[#A9190B] hover:text-white',
    },
    {
      id: 'acd34c7a-ce7e-46d9-a8bc-50ba45756953',
      description: 'Frangos',
      type: 'CATEGORY',
      regularClasses:
        'bg-[#E4840C] text-white border-[#E4840C]  hover:bg-white hover:text-[#E4840C]',
      activeClasses:
        'bg-white text-[#E4840C] border-[#E4840C]  hover:bg-[#E4840C] hover:text-white',
    },
    {
      id: '8d2e334d-687c-4b90-9337-c03c4da75747',
      description: 'Hambúrguer',
      type: 'CATEGORY',
      regularClasses:
        'bg-[#FF7F11] text-white border-[#FF7F11]  hover:bg-white hover:text-[#FF7F11]',
      activeClasses:
        'bg-white text-[#FF7F11] border-[#FF7F11]  hover:bg-[#FF7F11] hover:text-white',
    },
    {
      id: 'a6f42a0c-cd09-4c39-b987-ca60ff33ad3d',
      description: 'Pizza',
      type: 'CATEGORY',
      regularClasses:
        'bg-[#FF412F] text-white border-[#FF412F]  hover:bg-white hover:text-[#FF412F]',
      activeClasses:
        'bg-white text-[#FF412F] border-[#FF412F]  hover:bg-[#FF412F] hover:text-white',
    },
  ];
